import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Box } from '@qwealth/qcore';

import KypTable from './KypTable/KypTable';
import { getKyps, unloadKypData } from 'data/actions/KYP';
import TransitionBox from 'components/Households/Common/QNotes/TransitionBox';
import KypDetails from './KypDetails/KypDetails';
import KypSearchAndActionBar from './KypFilters/KypSearchAndActionBar';

const KypPage: FC = (): JSX.Element => {
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(window.innerWidth < 1600);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1600);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(unloadKypData());
    };
  }, []);

  return (
    <Box width="100%" height="fit-content" backgroundColor="white" padding="large">
      <Box fontSize="large" fontWeight="bold">
        QWealth Know Your Product
      </Box>

      <hr />

      <Box display="flex" flexDirection="row">
        <Box display="flex" flexDirection="row">
          <TransitionBox
            index={0}
            isVisible={true}
            marginTop="large"
            width="50%"
            height="100%"
            minWidth="75vh"
          >
            <KypSearchAndActionBar isSmallScreen={isSmallScreen} />
            <KypTable />
          </TransitionBox>

          <TransitionBox
            index={0}
            isVisible={true}
            marginTop="large"
            paddingLeft="largest"
            width="50%"
            height="100%"
            minWidth="75vh"
          >
            <KypDetails />
          </TransitionBox>
        </Box>
      </Box>
    </Box>
  );
};

export default KypPage;
